import { render, staticRenderFns } from "./Declaration.vue?vue&type=template&id=4e2e63bc"
import script from "./Declaration.vue?vue&type=script&lang=ts"
export * from "./Declaration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports